import axios from "axios";
import {message} from "antd";

// const
const MESSAGE_CENTER_UPDATE_DATA = "messageCenter/MESSAGE_CENTER_UPDATE_DATA";
const MESSAGE_CENTER_TOGGLE_LOADING = "messageCenter/MESSAGE_CENTER_TOGGLE_LOADING";
const MESSAGE_CENTER_STORE_MESSAGE_CATEGORIES = "messageCenter/MESSAGE_CENTER_STORE_MESSAGE_CATEGORIES";
const MESSAGE_CENTER_STORE_MESSAGES = "messageCenter/MESSAGE_CENTER_STORE_MESSAGES";
const MESSAGE_CENTER_STORE_RELOAD_MESSAGES = "messageCenter/MESSAGE_CENTER_STORE_RELOAD_MESSAGES";
const MESSAGE_CENTER_VIEW_MESSAGE = "messageCenter/MESSAGE_CENTER_VIEW_MESSAGE";

// reducer
export const messageCenter = (state = {

  loading: false,
  viewVisible: false,

  tabKey: "all",
  selectKeys: [],
  pageNumber: 1,
  pageSize: 10,
  total: 0,
  messageCategories: [],
  messages: [],
  message: {},

}, action) => {
  switch (action.type) {
    case MESSAGE_CENTER_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case MESSAGE_CENTER_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    case MESSAGE_CENTER_STORE_MESSAGE_CATEGORIES:
      return {
        ...state,
        messageCategories: action.data,
        tabKey: "all",
      };
    case MESSAGE_CENTER_STORE_MESSAGES:
      return {
        ...state,
        loading: false,
        viewVisible: false,
        tabKey: action.data.tabKey,
        pageNumber: action.data.number + 1,
        pageSize: action.data.size,
        total: action.data.totalElements,
        messages: action.data.content,
        message: {},
        selectKeys: [],
      };
    case MESSAGE_CENTER_STORE_RELOAD_MESSAGES:
      return {
        ...state,
        loading: false,
        viewVisible: false,
        tabKey: action.data.tabKey,
        pageNumber: action.data.number + 1,
        pageSize: action.data.size,
        total: action.data.totalElements,
        messages: action.data.content,
        message: {},
        selectKeys: [],
      };
    case MESSAGE_CENTER_VIEW_MESSAGE: {
      if (!action.data.hasRead) {
        state.messages.forEach(message => {
          if (message.id === action.data.id) {
            message.hasRead = true;
          }
        });
      }
      return {
        ...state,
        message: action.data,
        viewVisible: true
      };
    }
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateMessageCenterData = (data) => {
  return {
    type: MESSAGE_CENTER_UPDATE_DATA,
    data: data
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: MESSAGE_CENTER_TOGGLE_LOADING,
    data: show
  }
};

/**
 * get all message categories
 */
export const getMessageCategories = () => (dispatch) => {
  axios.get(`/api-message/messageCategories`, {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeMessageCategories(response.data));
        } else {
          message.warning("未获取到消息类别", 3);
        }
      }
    }
  ).catch(err => {
    message.error("获取消息类别失败", 3);
  });
};

/**
 * store all message categories
 */
export const storeMessageCategories = (messageCategories) => {
  return {
    type: MESSAGE_CENTER_STORE_MESSAGE_CATEGORIES,
    data: messageCategories
  }
};

/**
 * query messages
 */
export const queryMessages = (data) => (dispatch) => {
  switch (data.tabKey) {
    case "all":
      data.messageCategory = "";
      break;
    case "collect":
      data.hasCollect = true;
      break;
    case "delete":
      data.hasDelete = true;
      break;
    default:
      data.messageCategory = data.tabKey;
  }
  message.loading({content: "查询中……", key: "query"});
  axios({
    method: "POST",
    url: `/api-message/message/page/${data.userId}`,
    contentType: "application/json",
    withCredentials: true,
    data: data,
  }).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          message.success({content: "查询成功", key: "query", duration: 1});
          response.data.tabKey = data.tabKey;
          dispatch(storeMessages(response.data));
        } else {
          message.warning({content: "未查询到消息", key: "query", duration: 3});
        }
      }
    }
  ).catch(err => {
    message.error({content: "查询消息失败", key: "query", duration: 3});
  });
};

/**
 * store all messages
 */
export const storeMessages = (messages) => {
  return {
    type: MESSAGE_CENTER_STORE_MESSAGES,
    data: messages
  }
};

/**
 * reload messages
 */
export const reloadMessages = (data) => (dispatch) => {
  switch (data.tabKey) {
    case "all":
      data.messageCategory = "";
      break;
    case "collect":
      data.hasCollect = true;
      break;
    case "delete":
      data.hasDelete = true;
      break;
    default:
      data.messageCategory = data.tabKey;
  }
  axios({
    method: "POST",
    url: `/api-message/message/page/${data.userId}`,
    contentType: "application/json",
    withCredentials: true,
    data: data,
  }).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          response.data.tabKey = data.tabKey;
          dispatch(storeReloadMessages(response.data));
          message.success("刷新成功", 1);
        } else {
          message.warning("未查询到消息", 3);
        }
      }
    }
  ).catch(err => {
    message.error("刷新失败" + err.data.message, 3);
  });
};


/**
 * store reload messages
 */
export const storeReloadMessages = (messages) => {
  return {
    type: MESSAGE_CENTER_STORE_RELOAD_MESSAGES,
    data: messages
  }
};

/**
 * view message
 */
export const viewMessage = (data) => (dispatch) => {
  if (!data.hasRead) {
    axios({
      method: "PUT",
      url: "/api-message/message/read",
      contentType: "application/json",
      withCredentials: true,
      data: [data.id],
    }).catch(err => {
      message.error("标记已读错误" + err.data.message, 3);
    });
  }
  //id改为消息接收的id，便于在查看页面中标记、删除等操作
  data.message.id = data.id;
  data.message.hasRead = data.hasRead;
  dispatch(storeViewMessage(data.message));
};

/**
 * store view messages
 */
export const storeViewMessage = (message) => {
  return {
    type: MESSAGE_CENTER_VIEW_MESSAGE,
    data: message
  }
};

/**
 * read message
 */
export const readMessage = (data) => (dispatch) => {
  axios({
    method: "PUT",
    url: "/api-message/message/read",
    contentType: "application/json",
    withCredentials: true,
    data: data.selectKeys,
  }).then(
    response => {
      if (response.status === 200) {
        message.success("标记已读", 1);
        data.reload();
      } else {
        message.warning("标记已读失败", 3);
      }
    }
  ).catch(err => {
    message.error("标记已读错误：" + err.data.message, 3);
  });
};

/**
 * unRead message
 */
export const unReadMessage = (data) => (dispatch) => {
  axios({
    method: "PUT",
    url: "/api-message/message/unread",
    contentType: "application/json",
    withCredentials: true,
    data: data.selectKeys,
  }).then(
    response => {
      if (response.status === 200) {
        message.success("标记未读", 1);
        data.reload();
      } else {
        message.warning("标记未读失败", 3);
      }
    }
  ).catch(err => {
    message.error("标记未读错误：" + err.data.message, 3);
  });
};

/**
 * collect message
 */
export const collectMessage = (data) => (dispatch) => {
  axios({
    method: "PUT",
    url: "/api-message/message/collect",
    contentType: "application/json",
    withCredentials: true,
    data: data.selectKeys,
  }).then(
    response => {
      if (response.status === 200) {
        message.success("已收藏", 1);
        data.reload();
      } else {
        message.warning("收藏失败", 3);
      }
    }
  ).catch(err => {
    message.error("收藏错误：" + err.data.message, 3);
  });
};

/**
 * unCollect message
 */
export const unCollectMessage = (data) => (dispatch) => {
  axios({
    method: "PUT",
    url: "/api-message/message/uncollect",
    contentType: "application/json",
    withCredentials: true,
    data: data.selectKeys,
  }).then(
    response => {
      if (response.status === 200) {
        message.success("取消收藏", 1);
        data.reload();
      } else {
        message.warning("取消收藏失败", 3);
      }
    }
  ).catch(err => {
    message.error("取消收藏错误：" + err.data.message, 3);
  });
};

/**
 * delete message
 */
export const deleteMessage = (data) => (dispatch) => {
  axios({
    method: "DELETE",
    url: "/api-message/message/delete",
    contentType: "application/json",
    withCredentials: true,
    data: data.selectKeys,
  }).then(
    response => {
      if (response.status === 200) {
        message.success("已删除", 1);
        data.reload();
      } else {
        message.warning("删除失败", 3);
      }
    }
  ).catch(err => {
    message.error("删除错误：" + err.data.message, 3);
  });
};

/**
 * unDelete message
 */
export const unDeleteMessage = (data) => (dispatch) => {
  axios({
    method: "DELETE",
    url: "/api-message/message/undelete",
    contentType: "application/json",
    withCredentials: true,
    data: data.selectKeys,
  }).then(
    response => {
      if (response.status === 200) {
        message.success("已恢复", 1);
        data.reload();
      } else {
        message.warning("恢复失败", 3);
      }
    }
  ).catch(err => {
    message.error("恢复错误：" + err.data.message, 3);
  });
};

/**
 * cleanup message
 */
export const cleanupMessage = (data) => (dispatch) => {
  axios({
    method: "DELETE",
    url: "/api-message/message/cleanup",
    contentType: "application/json",
    withCredentials: true,
    data: data.selectKeys,
  }).then(
    response => {
      if (response.status === 200) {
        message.success("已永久删除", 1);
        data.reload();
      } else {
        message.warning("永久删除失败", 3);
      }
    }
  ).catch(err => {
    message.error("永久删除错误：" + err.data.message, 3);
  });
};
